export default {"src":"/_next/static/image/public/assets/images/my_car.442991888034a1a0b17d435b4bc1c8a8.svg","height":40,"width":40};